// extracted by mini-css-extract-plugin
export default {"dialog":"createModelGroupPopup_dialog__3xppu"};